import { IContactOptions } from '@r3f-component-data-structure';

// TODO: fix below!!
export const createVCardString = (d: IContactOptions): string => {
	for (const k in d) {
		const key = k as keyof typeof d;
		const val = d[key];
		if (typeof val === 'undefined' || !val) continue;
		d[key] = val
			.replace(/,/g, '%2C')
			.replace(/;/g, '%3B')
			.replace(/\n/g, '\\n');
	}

	const n = d.name.split(' ');
	const start = 'BEGIN:VCARD\nVERSION:3.0\n';
	const name = `N:${n[n.length] || ''};${n[0] || ''};;;\n`;
	const fName = `FN:${`${n[0]}` || ''}${n[n.length] || ''}\n`;
	const cName = d.company ? `ORG:${d.company}\n` : '';
	const prefTel = d.phone ? `TEL;TYPE=VOICE,PREF:${d.phone}\n` : '';
	const tel2 = d.phone2 ? `TEL;TYPE=VOICE:${d.phone2}\n` : '';
	const tel3 = d.phone3 ? `TEL;TYPE=VOICE:${d.phone3}\n` : '';
	const url = d.website ? `URL:${d.website}\n` : '';
	const email = d.email ? `EMAIL:${d.email}\n` : '';
	const photo = d.imgUrl ? `PHOTO;VALUE=uri:${d.imgUrl}\n` : '';
	const address = `ADR;TYPE=PREF:;;${`${d.street1} ` || ''}${d.street2 || ''};${
		d.city || ''
	};${d.county || ''};${d.zip || ''};${d.country || ''}\n`;
	const end = 'END:VCARD';

	return (
		start +
		name +
		fName +
		cName +
		prefTel +
		tel2 +
		tel3 +
		url +
		email +
		photo +
		address +
		end
	);
};
